import config from './config';
import store from '../store/index';

const axios = require('axios').default;

export default class Apicall {
    return = {
        status: 'OK',
    };

    header = {};

    getHeaders() {
        const thebearer = store.state.bearer;
        this.header = {
            headers: {
                Authorization: `Bearer ${thebearer}`,
            },
        };
        return this.header;
    }

    async getAvailablesFormationsForMe() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}videos/my-available-videos`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getVideoDetails(videoident) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}videos/video-details`, { ident: videoident }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getVideoContent(videoident) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}videos/video-content`, { ident: videoident }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async pushVideoTimeTracking(videoident, stack) {
        const self = this;
        const domain = config.basedomain;
        axios.post(`${domain}videos/video-tracking`, { ident: videoident, tracking: stack }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getNbInscriptions() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}preinscription/get-nb`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getNbUniqueViewersCount() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}formationstat/get-unique-viewers-count`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getNbMinutesViewed() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}formationstat/get-minutes-viewed`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getPreregistrationUsers() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}preinscription/get-users`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getPreregisterUserInfo(userid) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}preinscription/get-user-infos`, { uid: userid }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getAdminCategories() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}adminformation/get-categories`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async reordercat(_catid, _direction) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/order-category`, { catid: _catid, direction: _direction }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async deletecategory(_catid) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/delete-category`, { catid: _catid }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async saveCategory(_payload) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/save-category`, { payload: _payload }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getCategoryDetails(_catid) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/get-category-details`, { catid: _catid }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async lostPasswordRequest(_email) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}login/lost-password`, { email: _email }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async validatePasswordChangeToken(_token) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}login/validate-password-change-token`, { token: _token }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async changePasswordWithToken(_token, _pwd) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}login/change-password`, { token: _token, newpwd: _pwd }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async setVideoAsCompleted(_videoident) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}videos/mark-as-completed`, { ident: _videoident }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getMyInfos() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}me`, self.getHeaders()).then((response) => {
            self.return = response;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getformationsStats() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}formationstat/last-month-stats`, self.getHeaders()).then((response) => {
            self.return = response;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async validateCcv(_ccv) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}me/validate-ccv`, { ccv: _ccv }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async udpateMyProfile(_userinfos, _newpassword) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}me/udpate-my-infos`, { userinfos: _userinfos, newpassword: _newpassword }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getUsers() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}adminformation/get-users`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getUser(usersystemid) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/get-user-infos`, { systemid: usersystemid }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async updateUser(systemid, password, userinfos) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}adminformation/update-user`, { usersystemid: systemid, newpassword: password, ccvneeded: userinfos.ccvneeded }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getExamQuestions() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}examen/get-all-questions`, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async checkExamAnswers(_answers) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}examen/check-answers`, { answers: _answers }, self.getHeaders()).then((response) => {
            self.return = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }
}
